// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-3gr8b";
var _5 = "header-2906k";
var _6 = "titleWrapper-3W022";
var _7 = "back-2Y9aV";
var _8 = "title-2VPYr";
var _9 = "groups-2tunA";
var _a = "groups_item-2mZaD";
var _b = "groups_itemTitle-3hKLh";
var _c = "groups_itemIcon-3m_sA";
var _d = "groups_itemUnit-37zjT";
var _e = "groups_itemDescription-4a1KK";
var _f = "groups_itemValue-294Qe";
var _10 = "groups_itemValue_text-2l3lq";
var _11 = "slider-3hPj-";
var _12 = "arrow-3P9sJ";
var _13 = "arrow_prev-2GEgg";
var _14 = "slider_dots-2e2Sj";
var _15 = "image-26075";
var _16 = "content-1AiUE";
var _17 = "schema-1uT7A";
var _18 = "schemaZoom-1BV28";
var _19 = "footer-2Vxed";
var _1a = "cabins-6tKu-";
var _1b = "cabins_item-2pYeC";
var _1c = "cabins_itemIcon-226Jx";
var _1d = "Economy-1pg70";
var _1e = "Business-3B9gP";
var _1f = "Premium-3UnZE";
var _20 = "cabins_itemTitle-30k2M";
var _21 = "default_aircraft-1RM2r";
var _22 = "close-2b6j5";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "wrapper", _5 as "header", _6 as "titleWrapper", _7 as "back", _8 as "title", _9 as "groups", _a as "groups_item", _b as "groups_itemTitle", _c as "groups_itemIcon", _d as "groups_itemUnit", _e as "groups_itemDescription", _f as "groups_itemValue", _10 as "groups_itemValue_text", _11 as "slider", _12 as "arrow", _13 as "arrow_prev", _14 as "slider_dots", _15 as "image", _16 as "content", _17 as "schema", _18 as "schemaZoom", _19 as "footer", _1a as "cabins", _1b as "cabins_item", _1c as "cabins_itemIcon", _1d as "Economy", _1e as "Business", _1f as "Premium", _20 as "cabins_itemTitle", _21 as "default_aircraft", _22 as "close" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "wrapper": _4, "header": _5, "titleWrapper": _6, "back": _7, "title": _8, "groups": _9, "groups_item": _a, "groups_itemTitle": _b, "groups_itemIcon": _c, "groups_itemUnit": _d, "groups_itemDescription": _e, "groups_itemValue": _f, "groups_itemValue_text": _10, "slider": _11, "arrow": _12, "arrow_prev": _13, "slider_dots": _14, "image": _15, "content": _16, "schema": _17, "schemaZoom": _18, "footer": _19, "cabins": _1a, "cabins_item": _1b, "cabins_itemIcon": _1c, "Economy": _1d, "Business": _1e, "Premium": _1f, "cabins_itemTitle": _20, "default_aircraft": _21, "close": _22 }
